import { errorReportingService } from '@/services/errorReportingService';

/**
 * Setup global error handlers for uncaught errors
 */
export function setupGlobalErrorHandlers(): void {
  // Handle uncaught errors
  window.addEventListener('error', (event) => {
    errorReportingService.reportError(event.message, {
      severity: 'error',
      stack: event.error?.stack,
      errorCode: 'UNCAUGHT_ERROR',
      metadata: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    errorReportingService.reportError(`Unhandled Promise Rejection: ${event.reason}`, {
      severity: 'error',
      stack: event.reason?.stack,
      errorCode: 'UNHANDLED_REJECTION',
      metadata: {
        promise: event.promise?.toString(),
      },
    });
  });

  // Proxy console.error to capture explicit error logs
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    // Call original
    originalConsoleError.apply(console, args);

    // Report if first argument is an Error
    if (args[0] instanceof Error) {
      errorReportingService.reportError(args[0].message, {
        severity: 'warning',
        stack: args[0].stack,
        errorCode: 'CONSOLE_ERROR',
      });
    }
  };
}

/**
 * Cleanup global error handlers (for testing)
 */
export function cleanupGlobalErrorHandlers(): void {
  // Remove event listeners
  window.removeEventListener('error', () => {});
  window.removeEventListener('unhandledrejection', () => {});
}
